const removeLeadingSlash = string => {
  if (!string || !string.startsWith('/')) return string;
  return string.slice(1);
};
export { removeLeadingSlash };
//# sourceMappingURL=removeLeadingSlash.js.map
